import Badge, { badgeClasses } from '@mui/material/Badge';
import { styled } from '@mui/system';
const StyledBadge = styled(Badge)(({ theme, badgeContent }) => `
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 0.75rem;
  list-style: none;
  position: relative;
  display: inline-block;
  line-height: 1;

  & .${badgeClasses.badge} {
    z-index: auto;
    position: absolute;
    top: 7px;
    right: 8px;
    min-width: 0.4rem;
    height: 0.4rem;
    padding: 0 2px;
    font-family: Avenir;
    color: ${theme.palette.badgeAlert.main} ; //making it same color as bg, to hide the number
    font-weight: 500;
    font-size: 0px;
    line-height: 14px;
    display: block;
    white-space: nowrap;
    text-align: center;
    border-radius: 0.5rem;
    background: ${theme.palette.badgeAlert.main};
    transform:   ${badgeContent && String(badgeContent).length >= 3
    ? badgeContent && String(badgeContent).length >= 4
        ? 'translate(48%, -50%)'
        : 'translate(30%, -50%)'
    : 'translate(7%, -50%)'}; 
    
    transform-origin: 100% 0;
  }
  `);
export default {
    StyledBadge,
};
